import { type FC, useState } from 'react';

import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useShareToken } from '@/features/admin-interview';
import { type CandidateBasicDto } from '@/services/api';

import { IconWhatsapp } from '../../components/Icons';
import { WhatsappCandidatesConfirmationModal } from './WhatsappCandidatesConfirmationModal';

type WhatsappCandidatesCtaProps = {
  selectedCandidates: Array<CandidateBasicDto>;
  totalCandidates: number;
  interviewId?: string;
  onClearSelection: () => void;
};

export const WhatsappCandidatesCTA: FC<WhatsappCandidatesCtaProps> = ({
  selectedCandidates,
  totalCandidates,
  interviewId,
  onClearSelection,
}: WhatsappCandidatesCtaProps) => {
  const shareToken = useShareToken();
  const { t } = useTranslation(['candidate']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const count = selectedCandidates.length;

  if (count === 0) return null;

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        leftIcon={<IconWhatsapp fontSize="xl" color="gray.600" />}
        isDisabled={!!shareToken || totalCandidates === 0}
        size="md"
        px={3}
        variant="unstyled"
        w="full"
        textAlign="left"
        _hover={{ bg: 'gray.50' }}
        borderRadius={0}
      >
        {t('candidate:inviteNewCandidate.whatsappToCandidates', {
          count,
        })}
      </Button>

      <WhatsappCandidatesConfirmationModal
        isOpen={isModalOpen}
        onClose={() => {
          onClearSelection();
          setIsModalOpen(false);
        }}
        interviewId={interviewId ?? ''}
        selectedCandidates={selectedCandidates}
      />
    </>
  );
};
